export default async function getRequestFl({ context, nextMiddleware }){
    try {
        await context.store.dispatch('getOffices');
        await context.store.dispatch('getSysParameters');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware();
}
